import React, {
    useEffect,
    useContext,
    useState,
} from "react"

import EMETL404VM from "../ViewModel/EMETL404.vm"
import "./Stylesheets/EMETL404.css"

import { 
    Container, 
    Row, 
    Col, 
    Button,
} from "react-bootstrap"

import {
    Context,
} from "../Model/Contexts/AppContext"

const EMETL404 = () => {
    /*
     * Deconstruct all props using destructuring assignment
     * Model the props for each view in the ViewModel using a ts type
     * Add a props parameter of type "EMETL404Props" above.
     *
     * Most variables will be available in context or the view model.
     * Consume and destructure all needed context variables:
     */

    const {
        user,
        mode,
    } = useContext(Context)

    const [data, setData] = useState({})

    const load = async () => {
        // Use the view model functions to load data and return it (await)
        // Access state variables the user may have changed and

        return {}
    }

    const _init = async () => {
        const d = await load()
        setData(d)
    }

    const refresh = async () => {
        await _init()
        // Set additional state variables here...
    }

    useEffect(() => {
        if (user)
            EMETL404VM.user = user

        _init()
    }, [user])

    return (
        <Container 
            fluid 
            className="d-flex justify-content-center align-items-center" 
            id="emetl404"
        >
            <Col 
                md={6} 
                className="text-center p-4" 
                id="errorMessageContent"
                style={{ backgroundColor: "#ffffff", boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)" }}>
                <p 
                    style={{ 
                        fontSize: "72px", 
                        color: "#2c3e50",
                    }}
                >
                    404
                </p>
                <p 
                    style={{ 
                        fontSize: "18px", 
                        color: "#7f8c8d" 
                    }}
                >
                    Page Not Found
                </p>
                <p>
                    We're sorry, but the page you were looking for doesn't exist.
                </p>
                <Button 
                    variant="primary" 
                    onClick={() => window.location.href = "/"}
                >
                    Go Home
                </Button>
            </Col>
        </Container>
    )
}

export default EMETL404
